import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../../../../../../../components/calendars/assets/calendars.scss';
import { FormError } from '../../../../../../../components/redux-form/FormError';
import { FieldInput } from '../../../../../../../components/redux-form/fields/FieldInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { change } from 'redux-form';
import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import { Dispatch } from 'redux';

import { toast } from 'react-toastify';
import { FieldDate } from '../../../../../../../components/redux-form/fields/FieldDate';
import { asyncPersistSeance } from '../../../../../../../store/actions/seance-actions';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';
import { Button, Modal } from 'react-bootstrap';
import OrderEnum from '../../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';

export interface SeanceFormData {
    id?: string | number;
    occasion?: string | number;
    seanceDate: string | Date;
    startTime: string | Date;
    endTime: string | Date;
    isWeekly: boolean;
    detailPage?: boolean;
    editMode?: boolean;
    providerCalendar?: boolean;
    studentCalendar?: boolean;
    startTimeOld: Date | undefined;
    endTimeOld: Date | undefined;
    minPerUnit?: any;
    isHome?: boolean;
    isTelehealth?: boolean;
    isInPerson?: boolean;
    isSchool?: boolean;
    serviceLocation?: any;
    serviceType?: any;
    seanceInfo?: any;
    goals?: string;
    problem?: string;
    attendance?: string;
    plan?: string;
    month?: any;
    status?: number;
    providerId?: any;
    provider?: any;
    provId?: any;
    canEditSession?: string;
    studentId?: string;
    districtId?: string;
    vendorId?: string;
    columnForm?: boolean;
    hasPaid?: boolean;
}

interface SeanceFormProps {
    setData: (obj: any) => void;
    dispatch?: (obj: any) => void;
    existData: any;
    setExistData: (obj: any) => void;
    changeAction: boolean;
    hasPaid?: boolean;
}

type InjectedProps = InjectedFormProps<SeanceFormData, SeanceFormProps>;

const SeanceForm: React.FunctionComponent<InjectedProps & SeanceFormProps> = ({
                                                                                  handleSubmit,
                                                                                  error,
                                                                                  changeAction,
                                                                                  submitting,
                                                                                  dispatch,
                                                                                  setData,
                                                                                  existData,
                                                                                  setExistData,
                                                                                  hasPaid,
                                                                                  initialValues,
                                                                              }: InjectedProps & SeanceFormProps) => {
    const isSupervisor = user.getSupervisor();
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
    const isProvider = !user.getRoles().includes(UserRole.ROLE_ADMIN) && !isSupervisor;
    const isNew = !initialValues || !initialValues.id;
    const today = new Date();
    const isNotAllowChangeDate = !isAdmin && hasPaid;
    const disabled: boolean =
        (!!isProvider && !!initialValues.status && !!(+initialValues.status === 4)) || !!isNotAllowChangeDate;
    const [dataSaveModal, setSaveModal] = useState(false);
    const [isWeeklyClicked, setIsWeeklyClicked] = useState(false);

    const handleClick = (handleSubmit: (e: any) => void, e: any, isWeekly: boolean) => {
        if (existData?.length) {
            setSaveModal(true);
            if (isWeekly) {
                setIsWeeklyClicked(true);
            } else {
                setIsWeeklyClicked(false);
            }
        } else {
            if (isWeekly) {
                handleSub(handleSubmit, e);
            } else {
                handleSubNoWeekly(handleSubmit, e);
            }
        }
    };
    const typeOrderEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeOrderEnum);
    let valueOrderTypeLabel = '';
    if (existData?.length) {
        const valueOrderType = orderTypes.find((it) => it.value === existData[0].orderType);
        valueOrderTypeLabel = valueOrderType ? valueOrderType.label : '';
    }

    const handleSubExist = (handleSubmit: (e: any) => void, e: any) => {
        if (isWeeklyClicked) {
            handleSub(handleSubmit, e);
        } else {
            handleSubNoWeekly(handleSubmit, e);
        }
    };

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        dispatch && dispatch(change('event-form', 'isWeekly', true));
        setTimeout(() => {
            handleSubmit(e);
        }, 1000);
    };
    const handleSubNoWeekly = (handleSubmit: (e: any) => void, e: any) => {
        if (!isNew) {
            dispatch && dispatch(change('event-form', 'isWeekly', false));
        }
        setTimeout(() => {
            handleSubmit(e);
        }, 1000);
    };
    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="id"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldDate
                name="seanceDate"
                type="text"
                date={true}
                disabled={disabled}
                className="mr-5"
                wrapperConfig={{
                    label: 'Session Date:',
                }}
            />
            <FieldDate
                name="startTime"
                type="text"
                disabled={disabled}
                min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                time={true}
                step={5}
                formatType={'LT'}
                className="mr-5"
                wrapperConfig={{
                    label: 'Start Time:',
                }}
            />
            <FieldDate
                name="endTime"
                type="text"
                disabled={disabled}
                min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 7)}
                max={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 21)}
                time={true}
                formatType={'LT'}
                step={5}
                className="mr-5"
                wrapperConfig={{
                    label: 'End Time:',
                }}
            />
            {isNew ? (
                <FieldInput
                    disabled={disabled}
                    name="isWeekly"
                    type="checkbox"
                    wrapperConfig={{
                        label: 'Weekly',
                        classes: {
                            inputWrapper: 'customCheckbox',
                        },
                    }}
                />
            ) : (
                <FieldInput name="isWeekly" type="hidden" />
            )}
            {changeAction ? (
                <div className={classNames(styles.actions, 'd-flex justify-content-center text-center')}>
                    {isProvider && initialValues.status && +initialValues.status === 4 ? null : (
                        <button
                            type="button"
                            onClick={(event) => handleClick(handleSubmit, event, false)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    )}
                    {!isNew &&
                    initialValues.status &&
                    initialValues.isWeekly &&
                    [1, 3].includes(initialValues.status) ? (
                        <button
                            type="button"
                            onClick={(event) => handleClick(handleSubmit, event, true)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                        >
                            <FontAwesomeIcon icon={faSave} /> Update Weekly
                        </button>
                    ) : null}
                    {!isNew ? (
                        isProvider && initialValues.status && +initialValues.status === 4 ? null : (
                            <Link
                                target="_blank"
                                className={classNames('btn', 'btn-outline-info', 'mr-3')}
                                to={Router.generate(routes.PROVIDER_DETAIL, {
                                    subId: initialValues.id,
                                    id: initialValues.providerId,
                                    tab: 'case-sessions-edit',
                                })}
                            >
                                <FontAwesomeIcon icon={faStickyNote} /> <span>Note</span>
                            </Link>
                        )
                    ) : null}
                    <button
                        type="button"
                        className={classNames('btn', 'btn-danger')}
                        onClick={() => setData({ open: false, RenderData: <div></div> })}
                    >
                        <FontAwesomeIcon icon={faBan} /> Cancel
                    </button>

                    {existData?.length ? (
                        <Modal
                            show={dataSaveModal}
                            onHide={() => {
                                setSaveModal(false);
                            }}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Confirmation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                You have active {valueOrderTypeLabel} case for case number {existData[0].caseNumber}.
                                Are you sure you want to continue scheduling this session with the selected case?{' '}
                            </Modal.Body>
                            <Modal.Footer>
                                <form onSubmit={handleSubmit}>
                                    <Button
                                        className={'mr-2'}
                                        variant="secondary"
                                        onClick={() => {
                                            setSaveModal(false);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <button
                                        type="submit"
                                        onClick={(event) => handleSubExist(handleSubmit, event)}
                                        className={classNames('btn', 'btn-success', 'mr-3')}
                                    >
                                        <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                                    </button>
                                </form>
                            </Modal.Footer>
                        </Modal>
                    ) : null}
                </div>
            ) : null}
        </form>
    );
};

export default reduxForm<SeanceFormData, SeanceFormProps>({
    form: 'event-form',
    enableReinitialize: true,
    onSubmit: async (data: SeanceFormData, dispatch: Dispatch<any>, props: SeanceFormProps) => {
        await asyncPersistSeance(data, {}, dispatch);
    },
    onSubmitSuccess(result: any, dispatch: Dispatch<any>, props: DecoratedFormProps<SeanceFormData, SeanceFormProps>) {
        const isNew = !props.initialValues || !props.initialValues.id;
        props.setData({
            open: false,
            RenderData: <div></div>,
        });
        toast.success(`Session was successfully ${isNew ? 'created' : 'updated'}.`);
    },
    onSubmitFail(errors: { _error: string }) {
        if (errors._error) {
            toast.error(errors._error);
        }
    },
})(SeanceForm);
